module.exports = __webpack_public_path__ + "media/metronic/_theme/media/logos/logo-mini-md-2a5aacb08ca2b53000cce3132109490c.png";